






















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class SideNav extends Vue {
    @Prop() sidebarstate!: number;

    private Groups: boolean[] = [];
    private SubGroups: boolean[] = [];

    constructor() {
        super();
        for (let i = 0; i < 30; i++) {
            Vue.set(this.Groups, i, false);
            Vue.set(this.SubGroups, i, false);
        }
    }

    private IsExpanded(key: number) {
        return this.Groups[key];
    }

    private IsSubGroupExpanded(key: number) {
        return this.SubGroups[key];
    }

    private ToggleExpansion(key: number) {
        if (this.Groups[key] === true) {
            Vue.set(this.Groups, key, false);
        } else {
            Vue.set(this.Groups, key, true);
        }
    }

    private ToggleSubGroupExpansion(key: number) {
        if (this.SubGroups[key] === true) {
            Vue.set(this.SubGroups, key, false);
        } else {
            Vue.set(this.SubGroups, key, true);
        }
    }

    private visibilityMode() {
        if (this.sidebarstate < 0) {
            return 'nav-is-closed';
        } else {
            if (this.sidebarstate > 0) {
                return 'nav-is-open';
            } else {
                return 'nav-is-auto';
            }
        }
    }
}
